import { render, staticRenderFns } from "./app-sidebar.vue?vue&type=template&id=670ed813&scoped=true"
import script from "./app-sidebar.vue?vue&type=script&lang=js"
export * from "./app-sidebar.vue?vue&type=script&lang=js"
import style0 from "./app-sidebar.vue?vue&type=style&index=0&id=670ed813&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670ed813",
  null
  
)

export default component.exports